<div *ngIf="!disabled && active">
  <ng-content></ng-content>
</div>
